import { Calculator, Calendar, ArrowRight, ExternalLink } from 'lucide-react'

function SimulatorCard({ data }) {
  if (!data) return null

  const isRupture = data.simulator === 'rupture'
  const link = data.link || '#'

  return (
    <div className="cdg-response-card cdg-response-card-sim">
      <div className="cdg-response-card-header">
        <Calculator size={16} />
        <span>{isRupture ? 'Indemnité de rupture conventionnelle' : "Calcul d'ancienneté"}</span>
      </div>
      <div className="cdg-response-card-body">
        {isRupture && data.minimum != null && (
          <div className="cdg-sim-card-range">
            <div className="cdg-sim-card-val">
              <span className="val">{Number(data.minimum).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €</span>
              <span className="lbl">Minimum</span>
            </div>
            <ArrowRight size={16} className="cdg-sim-card-arrow" />
            <div className="cdg-sim-card-val">
              <span className="val">{Number(data.maximum).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €</span>
              <span className="lbl">Maximum</span>
            </div>
          </div>
        )}
        {!isRupture && data.duration && (
          <div className="cdg-sim-card-single">
            <span className="val">{data.duration}</span>
            <span className="lbl">Durée calculée</span>
          </div>
        )}
        {data.errors?.length > 0 && (
          <div className="cdg-response-card-warn">
            {data.simulator === 'anciennete' && !data.periods?.length
              ? 'Aucune période fournie. Utilisez le simulateur complet pour saisir vos données.'
              : data.errors.join(' · ')}
          </div>
        )}
      </div>
      <a href={link} className="cdg-response-card-link">
        Ouvrir le simulateur complet <ExternalLink size={12} />
      </a>
    </div>
  )
}

function ConcoursCard({ data }) {
  if (!data || !Array.isArray(data) || data.length === 0) return null

  return (
    <div className="cdg-response-card cdg-response-card-cal">
      <div className="cdg-response-card-header">
        <Calendar size={16} />
        <span>Prochains concours CDG31</span>
      </div>
      <div className="cdg-response-card-body">
        <table className="cdg-concours-table">
          <thead>
            <tr>
              <th>Concours</th>
              <th>Cat.</th>
              <th>Épreuves</th>
              <th>Limite</th>
            </tr>
          </thead>
          <tbody>
            {data.slice(0, 5).map((c, i) => (
              <tr key={i}>
                <td>
                  <a href={c.url} target="_blank" rel="noopener noreferrer">{c.titre}</a>
                </td>
                <td><span className={`cdg-cat-badge cat-${c.categorie}`}>{c.categorie}</span></td>
                <td>{c.date_epreuves}</td>
                <td>{c.date_limite}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default function ResponseCard({ card }) {
  if (!card || !card.card_type) return null

  switch (card.card_type) {
    case 'simulator_result':
      return <SimulatorCard data={card.data} />
    case 'concours_calendar':
      return <ConcoursCard data={card.data} />
    default:
      return null
  }
}
